// extracted by mini-css-extract-plugin
module.exports = {"fixedNav":"Header_fixedNav__2D10-","bottomMargin":"Header_bottomMargin__ugnZD"};